function areEqualShallow(obj1, obj2) {
    // if either is undefined then no equal
    if (!obj1 || !obj2)
        return false;
    // get keys from sanitized object
    var keys = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(obj1)));
    var keys2 = Object.getOwnPropertyNames(JSON.parse(JSON.stringify(obj2)));
    // first check if they have the same amount of properties
    if (keys.length !== Object.keys(keys2).length)
        return false;
    // test properties on original objects
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        if (obj1[key] !== obj2[key])
            return false;
    }
    // shallow equal
    return true;
}
export default areEqualShallow;
